@let assistant = aiAssistant();

<glxy-page>
  <glxy-page-toolbar>
    <glxy-page-nav>
      <glxy-page-nav-button [useHistory]="true" previousPageUrl="../" [useRelativePath]="true"></glxy-page-nav-button>
    </glxy-page-nav>
    <glxy-page-title>
      {{ (loading() ? '' : name()) || ('AI_ASSISTANT.SUMMARY.TITLE' | translate) }}
    </glxy-page-title>
    @let configureUrl = configurationUrl();
    @if (!loading() && assistant && configureUrl) {
      <glxy-page-actions>
        <a mat-flat-button color="primary" [routerLink]="[configureUrl]">
          <mat-icon>settings</mat-icon>
          {{ 'AI_ASSISTANT.SHARED.CONFIGURE' | translate }}
        </a>
      </glxy-page-actions>
    }
  </glxy-page-toolbar>

  @if (assistantNotFound()) {
    <glxy-page-wrapper>
      <mat-card>
        <glxy-empty-state [size]="'small'">
          <glxy-empty-state-hero>
            <mat-icon>error</mat-icon>
          </glxy-empty-state-hero>
          <glxy-empty-state-title>
            {{ 'AI_ASSISTANT.SUMMARY.EMPLOYEE_NOT_FOUND' | translate }}
          </glxy-empty-state-title>
          <p>{{ 'AI_ASSISTANT.SUMMARY.ERROR_FETCHING_EMPLOYEE' | translate }}</p>
        </glxy-empty-state>
      </mat-card>
    </glxy-page-wrapper>
  } @else if (loading()) {
    <glxy-loading-spinner></glxy-loading-spinner>
  } @else if (assistant) {
    <div class="identity-card">
      <div class="identity-content">
        @if (avatarSrc()) {
          <glxy-avatar class="identity-avatar" shape="square" [width]="avatarSize" [src]="avatarSrc()" />
        } @else {
          <glxy-avatar class="identity-avatar" shape="square" [width]="avatarSize" [svgIcon]="defaultAvatarIcon" />
        }
        <div class="identity-info">
          <div class="identity-heading">
            <h2 class="identity-name">{{ name() }}</h2>
            @if (typeLabel(); as type) {
              <span class="identity-type">{{ type }}</span>
            }
          </div>

          <p class="identity-description">
            {{
              descriptionKey() ? (descriptionKey() | translate) : ('AI_ASSISTANT.SUMMARY.NO_DESCRIPTION' | translate)
            }}
          </p>
        </div>
        @if (shouldShowChatButton() || shouldShowCallButton() || shouldShowTryItButton()) {
          <div class="identity-actions">
            @if (shouldShowTryItButton()) {
              <button mat-stroked-button (click)="onTryItClick()">
                {{ 'AI_ASSISTANT.WORKFORCE.TRY_IT' | translate }}
              </button>
            }
            @if (shouldShowChatButton()) {
              <button mat-stroked-button (click)="onChatButtonClick()">
                <mat-icon class="material-symbols-outlined">chat_bubble</mat-icon>
                {{ 'AI_ASSISTANT.WORKFORCE.CHAT_BUTTON' | translate }}
              </button>
            }
            @if (shouldShowCallButton()) {
              @if (
                webrtcCallState() === 'idle' || webrtcCallState() === 'disconnected' || webrtcCallState() === 'error'
              ) {
                <button mat-stroked-button (click)="openVoiceChat()">
                  <mat-icon>call</mat-icon>
                  {{ 'AI_ASSISTANT.WORKFORCE.WEBRTC.CALL' | translate }}
                </button>
              } @else if (webrtcCallState() === 'connecting') {
                <button mat-stroked-button disabled>
                  {{ 'AI_ASSISTANT.WORKFORCE.WEBRTC.CONNECTING' | translate }}
                </button>
              } @else if (webrtcCallState() === 'connected') {
                <button mat-flat-button color="warn" (click)="endVoiceChat()">
                  <mat-icon>call_end</mat-icon>
                  {{ 'AI_ASSISTANT.WORKFORCE.WEBRTC.END_CALL' | translate }}
                </button>
              }
            }
          </div>
        }
      </div>
    </div>
    @if (autonomyRating(); as rating) {
      @let autonomy = rating | autonomyLevel;

      <div class="autonomy-card">
        <h3>{{ 'AI_ASSISTANT.SUMMARY.AUTONOMY' | translate }}</h3>
        <mat-card>
          <mat-card-content>
            <p class="autonomy-level">
              {{
                'AI_ASSISTANT.AUTONOMY_LEVELS.LEVEL_TITLE_FORMAT'
                  | translate: { level: autonomy.level, title: (autonomy.levelTitle | translate) }
              }}
            </p>
            <p class="autonomy-description">{{ autonomy.levelDescription | translate }}</p>
          </mat-card-content>
        </mat-card>
      </div>
    }

    <mat-divider class="divider"></mat-divider>
    <glxy-page-wrapper>
      <div class="summary-cards">
        @if (isSuccessEvaluatorsEnabled() && jobsToBeDoneAssistantKey(); as assistantKey) {
          <mat-card>
            <mat-card-header class="full-width-header jobs-header">
              <mat-card-title>
                <div class="title-row">
                  <span>{{ 'AI_ASSISTANT.SETTINGS.JOBS_TO_BE_DONE' | translate }}</span>
                  @if (isCustomSuccessEvaluatorsEnabled()) {
                    <button type="button" mat-stroked-button (click)="addJobClicked()">
                      <mat-icon>add</mat-icon>
                      {{ 'AI_ASSISTANT.TESTING.JOBS_TO_BE_DONE.ADD_BUTTON' | translate }}
                    </button>
                  }
                </div>
              </mat-card-title>
              <mat-card-subtitle>
                @if (jobsWindowDays(); as days) {
                  {{ 'AI_ASSISTANT.SETTINGS.JOBS_TO_BE_DONE_DESCRIPTION_WITH_WINDOW' | translate: { days } }}
                } @else {
                  {{ 'AI_ASSISTANT.SETTINGS.JOBS_TO_BE_DONE_DESCRIPTION' | translate }}
                }
              </mat-card-subtitle>
            </mat-card-header>
            <mat-card-content>
              <ai-jobs-to-be-done [assistantKey]="assistantKey" [assistantType]="aiAssistant()?.assistant?.type"></ai-jobs-to-be-done>
            </mat-card-content>
          </mat-card>
        }

        @let connections = connectionsForm();
        @if (connections) {
          <ai-connections-form
            [connectionForms]="connections"
            [showManageButton]="assistant.showManageTriggersButton ?? true"
            [reviewTriggerBanner]="reviewTriggerBanner()"
            [blueprintAutomations]="blueprintAutomations()"
            [aiEmployeeName]="name()"
            [automationsBasePath]="automationsBase"
            (blueprintAutomationRefresh)="refreshBlueprintAutomations()"
          ></ai-connections-form>
        }

        <mat-card>
          <mat-card-header class="full-width-header">
            <mat-card-title>
              <div class="title-row">
                <span>{{ 'AI_ASSISTANT.SETTINGS.KNOWLEDGE_SOURCES' | translate }}</span>
                @if (knowledgeForm.dirty || knowledgeBasesDirty()) {
                  <span class="unsaved-changes-text">
                    {{ 'AI_ASSISTANT.SHARED.UNSAVED_CHANGES.TITLE' | translate }}
                  </span>
                }
              </div>
            </mat-card-title>
            <mat-card-subtitle>
              {{ 'AI_ASSISTANT.SETTINGS.KNOWLEDGE_SOURCES_DESCRIPTION' | translate }}
            </mat-card-subtitle>
          </mat-card-header>
          <mat-card-content class="no-top-margin">
            <ai-knowledge-application-knowledge
              [appId]="appId()"
              [enabled]="!fieldLocks().knowledge"
              [includeKnowledgeBases]="knowledgeGrantsEnabled()"
              (selectedSourcesChange)="updateSelectedSources($event)"
              (selectedKnowledgeBasesChange)="updateSelectedKnowledgeBases($event)"
              (loadStatusChange)="knowledgeLoadStatus.set($event)"
            ></ai-knowledge-application-knowledge>
          </mat-card-content>
        </mat-card>

        <mat-card>
          <mat-card-header class="full-width-header">
            <mat-card-title>
              <div class="title-row">
                <span>{{ 'AI_ASSISTANT.SETTINGS.AUTOMATIONS' | translate }}</span>
              </div>
            </mat-card-title>
            <mat-card-subtitle>
              {{ 'AI_ASSISTANT.SETTINGS.AUTOMATIONS_DESCRIPTION' | translate }}
            </mat-card-subtitle>
          </mat-card-header>
          <mat-card-content class="no-top-margin">
            <ai-incoming-automations
              [employeeId]="assistantId()"
              [disableNavigation]="isNativeApp"
              [automationsBasePath]="automationsBase"
            ></ai-incoming-automations>
          </mat-card-content>
          <!-- Matches the configuration page, which also hides automations navigation on native rather
               than linking out of the app. Kept consistent rather than diverging on one surface. -->
          @if (!isNativeApp) {
            <mat-card-footer class="card-footer">
              <a mat-stroked-button [routerLink]="[automationsBase, 'automations']">
                {{ 'AI_ASSISTANT.SETTINGS.MANAGE_AUTOMATIONS' | translate }}
              </a>
            </mat-card-footer>
          }
        </mat-card>
      </div>
      <ai-sticky-footer
        (submitClick)="save()"
        [hideCancel]="true"
        [disabled]="submitDisabled()"
        [saving]="saving()"
        [showUnsavedChangesIndicator]="dirty()"
      />
    </glxy-page-wrapper>
  }
</glxy-page>
